import { render, staticRenderFns } from "./DetailTab.vue?vue&type=template&id=ca80ede6&scoped=true&"
import script from "./DetailTab.vue?vue&type=script&lang=ts&"
export * from "./DetailTab.vue?vue&type=script&lang=ts&"
import style0 from "./DetailTab.vue?vue&type=style&index=0&id=ca80ede6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80ede6",
  null
  
)

export default component.exports